export default __webpack_public_path__ + "static/bg-business-dilemma-1c56647fca0626d85da3f3f4606d9d0f.png";